module.exports = __webpack_public_path__ + "img/product7.68b311d2.png";